<!--查看评论-->
<template>
  <div class="page" v-cloak>
    <van-nav-bar left-arrow fixed title="商品评价" id="nav-bar" @click-left="onClickLeft"></van-nav-bar>

    <div class="product-rate">
      <p> 综合评分：
        <van-rate size="12" v-model="rate" color="#ffd21e" void-icon="star" readonly allow-half void-color="#eee" />
      </p>
      <p>评分<span class="rate-num">3.5分</span> </p>
    </div>
    <!-- 黏顶搜索框 -->
    <van-sticky :offset-top="46">
      <van-tabs v-model="active" title-active-color="#00A8C0" color="#00A8C0" title-inactive-color="#78849E">
       <van-tab v-for="(item, index) in tabsList" :key="index" :title="item.name"></van-tab>
      </van-tabs>
    </van-sticky>

    <div class="list">
      <img-text-comment v-for="(item, index) in list" :key="index" :show-type="'on'" :ind="index" :info="item"></img-text-comment>
    </div>
  </div>
</template>

<script type="text/babel">
import imgTextComment from "@/components/img-text-comment/img-text-comment.vue";
export default {
  name: 'commentSee',
  components: { imgTextComment },
  props: {},
  data() {
    return {
      rate: 3.5,
      active:0,
      tabsList:[
        {  id:1, name:"全部"},
        {  id:2, name:"最新"},
        {  id:3, name:"图评"},
        {  id:4, name:"好评"},
        {  id:5, name:"差评"},
      ],
      list: [

        {
          id: '1',
          rate: 2.9,
          time: '2020-03-03',
          userImg: 'http://qiniu.zdyxjx.com/product/upload_pic_1599124191028',
          userName: '周**好',
          sku: '颜色：黑色；规格：大号',
          comment: '拆完快递看到东西我就激动哭了，这也太好看了吧，非常好看。再也不担心耳机线了，非常方便，音质很棒。',
          imgList: [
            "http://qiniu.zdyxjx.com/product/upload_pic_1608273324800",
            "http://qiniu.zdyxjx.com/product/upload_pic_1608273324802",
            "http://qiniu.zdyxjx.com/product/upload_pic_1608273324804",
            "http://qiniu.zdyxjx.com/product/upload_pic_1608273324806",
            "http://qiniu.zdyxjx.com/product/upload_pic_1608273324808",
          ],
          product: [
            {
              productId: "12131",
              name: "乐扣乐扣-莹彩蓝轻量保温杯",
              imageUrl: "http://qiniu.zdyxjx.com/product/upload_pic_1608275023065",
              description: "乐扣乐扣-莹彩蓝轻量保温杯",
              showPrice: 100.00,
              price: 1000.0,
              costPrice: 100.00,
              quantity: 1000,
              ordinal: 0,
              state: 1,
            },
            {
              productId: "12131",
              name: "乐扣乐扣-莹彩蓝轻量保温杯",
              imageUrl: "http://qiniu.zdyxjx.com/product/upload_pic_1608275023065",
              description: "乐扣乐扣-莹彩蓝轻量保温杯",
              showPrice: 100.00,
              price: 1000.0,
              costPrice: 100.00,
              quantity: 1000,
              ordinal: 0,
              state: 1,
            },
          ]
        }, {
          id: '1',
          rate: 3,
          time: '2020-03-03',
          userImg: 'http://qiniu.zdyxjx.com/product/upload_pic_1599124191028',
          userName: '周**好',
          sku: '颜色：黑色；规格：大号',
          comment: '拆完快递看到东西我就激动哭了，这也太好看了吧，非常好看。再也不担心耳机线了，非常方便，音质很棒。',
          imgList: ['http://qiniu.zdyxjx.com/product/upload_pic_1608275023065', 'http://qiniu.zdyxjx.com/product/upload_pic_1608275023065'],
          product: [
            {
              productId: "12131",
              name: "乐扣乐扣-莹彩蓝轻量保温杯",
              imageUrl: "http://qiniu.zdyxjx.com/product/upload_pic_1608275023065",
              description: "乐扣乐扣-莹彩蓝轻量保温杯",
              showPrice: 100.00,
              price: 1000.0,
              costPrice: 100.00,
              quantity: 1000,
              ordinal: 0,
              state: 1,
            }
          ]
        }, {
          id: '1',
          rate: 4,
          time: '2020-03-03',
          userImg: 'http://qiniu.zdyxjx.com/product/upload_pic_1599124191028',
          userName: '周**好',
          sku: '颜色：黑色；规格：大号',
          comment: '拆完快递看到东西我就激动哭了，这也太好看了吧，非常好看。再也不担心耳机线了，非常方便，音质很棒。',
          imgList: [],
          product: [
            {
              productId: "12131",
              name: "乐扣乐扣-莹彩蓝轻量保温杯",
              imageUrl: "http://qiniu.zdyxjx.com/product/upload_pic_1608275023065",
              description: "乐扣乐扣-莹彩蓝轻量保温杯",
              showPrice: 100.00,
              price: 1000.0,
              costPrice: 100.00,
              quantity: 1000,
              ordinal: 0,
              state: 1,
            }
          ]
        }, {
          id: '1',
          rate: 5,
          time: '2020-03-03',
          userImg: 'http://qiniu.zdyxjx.com/product/upload_pic_1599124191028',
          userName: '周**好',
          sku: '',
          comment: '拆完快递看到东西我就激动哭了，这也太好看了吧，非常好看。再也不担心耳机线了，非常方便，音质很棒。',
          imgList: ['http://qiniu.zdyxjx.com/product/upload_pic_1608275023065', 'sss', 'http://qiniu.zdyxjx.com/product/upload_pic_1608275023065'],
          product: [
            {
              productId: "12131",
              name: "乐扣乐扣-莹彩蓝轻量保温杯",
              imageUrl: "http://qiniu.zdyxjx.com/product/upload_pic_1608275023065",
              description: "乐扣乐扣-莹彩蓝轻量保温杯",
              showPrice: 100.00,
              price: 1000.0,
              costPrice: 100.00,
              quantity: 1000,
              ordinal: 0,
              state: 1,
            }
          ]
        },
      ]
    }
  },
  watch: {

  },
  created() { },
  mounted() { },
  methods: {
    // 返回上一页
    onClickLeft() {
      this.$router.go(-1)
    },

  }
}
</script>

<style lang="scss" scoped>
.page {
  // height: 100%;
  width: 100%;
  padding: 46px 0;
  background-color: #f9f9f9;
  .product-rate {
    padding: 0 10px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    background-color: #fff;
    font-size: 15px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    line-height: 26px;
    color: #999999;

    .rate-num {
      color: #ff8947;
    }
  }
  .list {
    padding: 0 10px;
  }
}
</style>
